import { Component } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { SubscriberMailUsersService } from './subscriber-mail-users.service';

@Component({
  selector: 'app-subscriber-mail-users',
  templateUrl: './subscriber-mail-users.component.html',
  styleUrl: './subscriber-mail-users.component.scss'
})
export class SubscriberMailUsersComponent {
  email: any;
  userData: any;
  totalEnabledUsers: number = 0;
  mailSent: number = 0;
  loading = true;
  emailToDelete: string | null = null;
  showDeleteDialog: boolean = false;

  constructor(public toastr: ToastrService, private SubscriberMailUsersService: SubscriberMailUsersService, private sanitized: DomSanitizer) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.GetUserList();
  }

  GetUserList(): void {
    if (this.email) {
      this.SubscriberMailUsersService.getSubscriberMailUsers(this.email).subscribe(
        response => {
          this.userData = response;
          this.totalEnabledUsers = response.total_count; // Directly use the total_count from response
          this.mailSent = response.mail_sent; // Directly use the mail_sent from response
          this.loading = false;
        },
        error => {
          this.toastr.error('Failed to fetch user data', 'Error');
        }
      );
    }
  }

  confirmDelete(email: string): void {
    this.emailToDelete = email;
    this.showDeleteDialog = true;
  }

  deleteUser(): void {
    if (this.emailToDelete) {
      const payload = { email: this.emailToDelete };
      this.SubscriberMailUsersService.DeleteSubscriberMailUser(payload).subscribe(
        response => {
          this.toastr.success('User deleted successfully', 'Success');
          this.GetUserList(); // Refresh user data
          this.showDeleteDialog = false;
        },
        error => {
          this.toastr.error('Failed to delete user', 'Error');
          this.showDeleteDialog = false;
        }
      );
    }
  }


}
